import { useContext, useState, useEffect, useRef, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { AgencyContext } from 'Context/Agency'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { base64ToString, Decrypt_Id_Name, stringToBase64 } from '@/Components/Common/Utility';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import StatusBar from '@/Components/Inc/StatusBar';
import { useNibrs } from '@/Context/NIBRS/NibrsLeftTreeContext';

const IncSidebar = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const statusRef = useRef(null);
    const localStoreData = useSelector((state) => state.Agency.localStoreData);
    // Agency ID
    const loginAgencyID = localStoreData?.AgencyID || '';

    const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
    const { nibrsLeftTreeErrorsData } = useNibrs();

    const useQuery = () => {
        const params = new URLSearchParams(useLocation().search);
        return {
            get: (param) => params.get(param)
        };
    };

    let DecEIncID = 0;
    const query = useQuery();
    const qpOrZero = (v) => (v !== null && v !== undefined && v !== '' && v !== 'undefined' ? v : 0);
    let openPage = query?.get('page');
    var ModNo = query?.get('ModNo');
    var ArrNo = query?.get("ArrNo");
    var IncID = query?.get("IncId");
    var ArrestId = query?.get("ArrestId");
    var IncNo = query?.get("IncNo");
    var IncSta = query?.get("IncSta");
    var ArrNo = query?.get("ArrNo");
    var Name = query?.get("Name");
    var ArrestSta = query?.get("ArrestSta");
    var ChargeSta = query?.get("ChargeSta");
    var NameID = query?.get("NameID");
    var MasterNameID = query?.get("MasterNameID");
    var NameStatus = query?.get("NameStatus");
    var SideBarStatus = query?.get("SideBarStatus");
    var localStorageStatus = query?.get("localStorageStatus");
    var propPageProId = query?.get("ProId");
    var propPageMProId = query?.get("MProId");
    var propPageProSta = query?.get("ProSta");
    var propPageProCategory = query?.get("ProCategory");
    var offPageOffId = query?.get("OffId");
    var offPageOffSta = query?.get("OffSta");

    if (!IncID) IncID = 0;
    else DecEIncID = parseInt(base64ToString(IncID));

    if (!IncNo) IncNo = '';
    else IncNo = IncNo;

    if (!ArrestId) ArrestId = 0;
    else ArrestId = ArrestId;
    if (!ArrNo) ArrNo = 0;
    if (!Name) Name = 0;
    if (!ArrestSta) ArrestSta = 0;
    if (!ChargeSta) ChargeSta = 0;
    if (!NameID) NameID = 0;
    if (!MasterNameID) MasterNameID = 0;
    if (!NameStatus) NameStatus = true;

    const sideBarStatusVal = qpOrZero(SideBarStatus) === 0 ? 'false' : String(SideBarStatus);
    const localStorageStatusVal = qpOrZero(localStorageStatus) === 0 ? 'true' : String(localStorageStatus);
    const chargeStaVal = ChargeSta === true || ChargeSta === 'true' ? 'true' : 'false';

    const { changesStatus, incidentCount, setActiveArrest, CaseStatus, validate_IncSideBar, incidentErrorStatus, offenseErrorStatus, nameErrorStatus, NameRelationshipError, narrativeApprovedStatus, PropErrorStatus, vehErrorStatus, nibrsSideBarLoading
    } = useContext(AgencyContext);
    const [agencyName, setAgencyName] = useState('');
    const [selectedErrorKey, setSelectedErrorKey] = useState('');
    const [categoryModalContent, setCategoryModalContent] = useState('');
    const [categoryModalHeader, setCategoryModalHeader] = useState('');

    const ASSOCIATED_OFFENSE_CATEGORY_MESSAGE = `
510 = Bribery
220 = Burglary/Breaking & Entering
250 = Counterfeiting/Forgery
270 = Embezzlement
210 = Extortion/Blackmail
26A = False Pretenses/Swindle/Confidence Game
26B = Credit Card/Automated Teller Machine Fraud
26C = Impersonation
26D = Welfare Fraud
26E = Wire Fraud
26F = Identity Theft
26G = Hacking/Computer Invasion
26H = Money Laundering
100 = Kidnapping/Abduction
23A = Pocket-picking
23B = Purse-snatching
23C = Shoplifting
23D = Theft From Building
23E = Theft From Coin Operated Machine
23F = Theft From Motor Vehicle
23G = Theft of Motor Vehicle Parts or Accessories
23H = All Other Larceny
240 = Motor Vehicle Theft
120 = Robbery
280 = Stolen Property Offenses`;

    const ASSOCIATED_OFFENSE_CATEGORY_MESSAGE_6 = `
200 = Arson-Attempted
510 = Bribery-Attempted/Completed
220 = Burglary/Breaking & Entering-Attempted/Completed
250 = Counterfeiting/Forgery-Attempted
290 = Destruction/Damage/Vandalism of Property-Attempted
35A = Drug/Narcotic Violations-Attempted
35B = Drug Equipment Violations-Attempted
270 = Embezzlement-Attempted
210 = Extortion/Blackmail-Attempted
26A = False Pretenses/Swindle/Confidence Game-Attempted
26B = Credit Card/Automated Teller Machine Fraud- Attempted
26C = Impersonation-Attempted
26D = Welfare Fraud-Attempted
26E = Wire Fraud-Attempted
26F = Identity Theft-Attempted
26G = Hacking/Computer Invasion- Attempted
39A = Betting/Wagering-Attempted
39B = Operating/Promoting/Assisting Gambling-Attempted
39C = Gambling Equipment Violations- Attempted
39D = Sports Tampering-Attempted
100 = Kidnapping/Abduction-Attempted/Completed
23A = Pocket-picking-Attempted
23B = Purse-snatching-Attempted
23C = Shoplifting-Attempted
23D = Theft From Building-Attempted
23E = Theft From Coin-Operated Machine or Device-Attempted
23F = Theft From Motor Vehicle-Attempted
23G = Theft of Motor Vehicle Parts or Accessories-Attempted
23H = All Other Larceny- Attempted
240 = Motor Vehicle Theft- Attempted
120 = Robbery-Attempted
280 = Stolen Property Offenses-Attempted`;

    const ASSOCIATED_OFFENSE_CATEGORY_MESSAGE_8 = `
250 = Counterfeiting/Forgery
35A = Drug/Narcotics Violations
35B = Drug Equipment Violations
39A = Betting/Wagering
39B = Operating/Promoting/Assisting Gambling
39C = Gambling Equipment
39D = Sports Tampering`;

    const ASSOCIATED_OFFENSE_CATEGORY_MESSAGE_7 = `
510 = Bribery
220 = Burglary/Breaking & Entering
270 = Embezzlement
210 = Extortion/Blackmail
26A = False Pretenses/Swindle/Confidence Game
26B = Credit Card/Automated Teller Machine Fraud
26C= Impersonation
26D = Welfare Fraud
26E = Wire Fraud
26F = Identity Theft
26G = Hacking/Computer Invasion
100 = Kidnapping/Abduction
23A = Pocket-picking
23B = Purse-snatching
23C = Shoplifting
23D = Theft From Building
23E = Theft From Coin Operated Machine
23F = Theft From Motor Vehicle
23G = Theft of Motor Vehicle Parts or Accessories
23H = All Other Larceny
240 = Motor Vehicle Theft
120 = Robbery`;

    const LOSS_TYPE_CATEGORY_MESSAGE = `
Crime against property
100 = Kidnapping/Abduction
Drug/Narcotic Offenses (35A–35B)
Gambling Offenses (39A–39D)`;

    // Incident Count
    const offenseCount = incidentCount[0]?.OffenseCount || 0;
    const NameCount = incidentCount[0]?.NameCount || 0;
    const PropertyCount = incidentCount[0]?.PropertyCount || 0;
    const VehicleCount = incidentCount[0]?.VehicleCount || 0;


    useEffect(() => {
        if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
            if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
        }
    }, []);

    useEffect(() => {
        if (localStoreData) {
            setAgencyName(localStoreData?.Agency_Name);
        }
    }, [localStoreData]);

    const currentLocation = window.location.pathname + window.location.search;


    const victimRequiredErrors = useMemo(
        () =>
            (nibrsLeftTreeErrorsData || []).filter(
                (item) =>
                    item?.ErrorCode === "Error_Victim" &&
                    (
                        item?.FieldPath === "victim_required" ||
                        item?.FieldPath === "victim_offense_link" ||
                        item?.FieldPath === "offense_victim_link" ||
                        item?.FieldPath === "victim_data_elements" ||
                        item?.FieldPath === "offense_murder" ||
                        item?.FieldPath === "offense_Aggravate_Assault" ||
                        item?.FieldPath === "offense_Simple_Assault" ||
                        item?.FieldPath === "offense_Intimidation" ||
                        item?.FieldPath === "offense_negligent_Manslaughter" ||
                        item?.FieldPath === "offense_Rape_Sodomy_SexualAssault" ||
                        item?.FieldPath === "offense_CriminalSexualContact" ||
                        item?.FieldPath === "offense_Incest_StatutoryRape" ||
                        item?.FieldPath === "offense_Robbery" ||
                        item?.FieldPath === "incident_validation" ||
                        item?.FieldPath === "offense_09C_offender_required" ||
                        item?.FieldPath === "arrestee_Unarmed" ||
                        item?.FieldPath === "arrestee_GroupB_Required" ||
                        item?.FieldPath === "victim_offender_relationship" ||
                        item?.FieldPath === "victim_offender_relationship.vo_reciprocal" ||
                        item?.FieldPath === "arrestee_Error656" ||
                        item?.FieldPath === "property_required" ||
                        item?.FieldPath === "property_offense_link" ||
                        item?.FieldPath === "Error_T487" ||
                        item?.FieldPath === "Error_T585" ||
                        item?.FieldPath === "offender_required" ||
                        item?.FieldPath === "segment9T980" ||
                        item?.FieldPath === "segment9_ErrorT981" ||
                        item?.FieldPath === "segment9_ErrorT982" ||
                        item?.FieldPath === "segment9_ErrorT983" ||
                        item?.FieldPath === "property_loss_type" ||
                        item?.FieldPath === "property.associated_offense" ||
                        item?.FieldPath === "property_Associat_OffenseError" ||
                        item?.FieldPath === "vehicle_required" ||
                        item?.FieldPath === "victim_property_or_arrest_required" ||
                        item?.FieldPath === "victim_Error080" ||
                        item?.FieldPath === "Society_Victim_required" ||
                        item?.FieldPath === "property.date_recovered" ||
                        item?.FieldPath === "victim.de24_type_of_victim" ||
                        item?.FieldPath === "offense.property_association" ||
                        item?.FieldPath === "property_35A_Drug" ||
                        item?.FieldPath === "property.type_property_loss" ||
                        item?.FieldPath === "arrestee.charge" ||
                        item?.FieldPath === "property_offense" ||
                        item?.FieldPath === "property.loss_type"
                    )
            ),
        [nibrsLeftTreeErrorsData]
    );

    const handleVictimRequiredRedirect = (fieldPath, contextJson) => {
        if (fieldPath === "victim_required" || fieldPath === "incident_validation" || fieldPath === "offense_09C_offender_required" || fieldPath === "victim_offender_relationship" || fieldPath === "Error_T487" || fieldPath === "offender_required" || fieldPath === "victim_Error080") {
            navigate(`/Name-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&NameID=0&MasterNameID=0&NameStatus=null`);
        } else if (fieldPath === "victim_offense_link" || fieldPath === "offense_murder" ||
            fieldPath === "offense_Aggravate_Assault" ||
            fieldPath === "offense_Simple_Assault" ||
            fieldPath === "offense_Intimidation" ||
            fieldPath === "offense_negligent_Manslaughter" ||
            fieldPath === "offense_Rape_Sodomy_SexualAssault" ||
            fieldPath === "offense_CriminalSexualContact" ||
            fieldPath === "offense_Incest_StatutoryRape" ||
            fieldPath === "offense_Robbery") {
            navigate(`/Name-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&NameID=${contextJson?.name_id ? stringToBase64(contextJson?.name_id) : NameID}&MasterNameID=${contextJson?.master_name_id ? stringToBase64(contextJson?.master_name_id) : MasterNameID}&NameStatus=${NameStatus}&activeTab=Offense`);
        } else if (fieldPath === "victim_data_elements") {
            navigate(`/Name-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&NameID=${contextJson?.victims?.[0]?.name_id ? stringToBase64(contextJson?.victims?.[0]?.name_id) : NameID}&MasterNameID=${contextJson?.victims?.[0]?.master_name_id ? stringToBase64(contextJson?.victims?.[0]?.master_name_id) : MasterNameID}&NameStatus=${NameStatus}&activeTab=Victim`);
        } else if (fieldPath === "victim_offender_relationship.vo_reciprocal" || fieldPath === "Error_T585") {
            navigate(`/Offvic-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}`);
        } else if (fieldPath === "arrestee_GroupB_Required") {
            navigate(`/Arrest-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ArrestId=${ArrestId}&ArrNo=${ArrNo}&Name=${Name}&ArrestSta=${ArrestSta}&ChargeSta=${ChargeSta}`);
        } else if (fieldPath === "arrestee_Unarmed") {
            navigate(`/Arrest-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ArrestId=${contextJson?.arrest_id ? stringToBase64(contextJson?.arrest_id) : ArrestId}&ArrNo=${contextJson?.arrest_transaction_number}&Name=${Name}&ArrestSta=${ArrestSta}&ChargeSta=${ChargeSta}&activeTab=Charges`);
        } else if (fieldPath === "arrestee_Error656") {
            navigate(
                `/Arrest-Home?IncId=${qpOrZero(IncID)}&IncNo=${qpOrZero(IncNo)}&IncSta=${qpOrZero(IncSta)}&ArrestId=${qpOrZero(ArrestId)}&ArrestSta=${qpOrZero(ArrestSta)}&ArrNo=${qpOrZero(ArrNo)}&Name=${qpOrZero(Name)}&SideBarStatus=${sideBarStatusVal}&ChargeSta=${chargeStaVal}&localStorageStatus=${localStorageStatusVal}`
            );
        } else if (fieldPath === "property_required") {
            navigate(`/Prop-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ProId=0&MProId=0&ProSta=true`);
        } else if (fieldPath === "property_offense_link" || fieldPath === "property.associated_offense" || fieldPath === "property_Associat_OffenseError") {
            const proIdQ = qpOrZero(propPageProId);
            const mProIdQ = qpOrZero(propPageMProId);
            const proStaQ = propPageProSta !== null && propPageProSta !== undefined && propPageProSta !== '' ? propPageProSta : 'null';
            const proCatQ = encodeURIComponent(propPageProCategory || '');
            if (contextJson?.vehicle_id) {
                navigate(`/Vehicle-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${contextJson?.property_id ? stringToBase64(contextJson?.property_id) : null}&MVehId=${contextJson?.master_property_id ? stringToBase64(contextJson?.master_property_id) : null}&VehSta=true&activeTab=Offense`);
            } else {
                navigate(`/Prop-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ProId=${contextJson?.property_id ? stringToBase64(contextJson?.property_id) : proIdQ}&MProId=${contextJson?.master_property_id ? stringToBase64(contextJson?.master_property_id) : mProIdQ}&ProSta=true&ProCategory=${proCatQ}&activeTab=Offense`);
            }
        } else if (fieldPath === "segment9T980" || fieldPath === "segment9_ErrorT981" || fieldPath === "segment9_ErrorT982" || fieldPath === "segment9_ErrorT983" || fieldPath === "property_loss_type") {
            const offIdQ = qpOrZero(offPageOffId);
            const offStaQ = offPageOffSta !== null && offPageOffSta !== undefined && offPageOffSta !== '' ? offPageOffSta : 'null';
            navigate(`/Off-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&OffId=${contextJson?.crime_id ? stringToBase64(contextJson?.crime_id) : offIdQ}&OffSta=${offStaQ}`);
        } else if (fieldPath === "vehicle_required") {
            navigate(`/Vehicle-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=0&MVehId=0&VehSta=null`);
        } else if (fieldPath === "Society_Victim_required") {
            navigate(`/Name-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&NameID=0&MasterNameID=0&NameStatus=null&NameTypeCode=S`);
        } else if (fieldPath === "property.date_recovered") {
            if (contextJson?.vehicle_id) {
                navigate(`/Vehicle-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${contextJson?.property_id ? stringToBase64(contextJson?.property_id) : null}&MVehId=${contextJson?.master_property_id ? stringToBase64(contextJson?.master_property_id) : null}&VehSta=true&activeTab=RecoveredVehicle`);
            } else {
                navigate(`/Prop-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ProId=${contextJson?.property_id ? stringToBase64(contextJson?.property_id) : null}&MProId=${contextJson?.master_property_id ? stringToBase64(contextJson?.master_property_id) : null}&ProSta=true&ProCategory=${contextJson?.property_type ? contextJson?.property_type : null}&activeTab=RecoveredProperty`);
            }
        } else if (fieldPath === "offense.property_association") {
            navigate(`/Prop-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ProId=&MProId=&ProSta=null&ProCategory=&Type=Drug&isNew=true`);
        } else if (fieldPath === "arrestee.charge") {
            navigate(`/Arrest-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ArrestId=${contextJson?.arrest_id ? stringToBase64(contextJson?.arrest_id) : ArrestId}&ArrNo=${contextJson?.arrest_transaction_number}&Name=${Name}&ArrestSta=${ArrestSta}&ChargeSta=${ChargeSta}&activeTab=Charges`);
        } else if (fieldPath === "property_offense") {
            navigate(`/Off-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&OffId=0&OffSta=false&isNew=true`);
        } else if (fieldPath === "property.loss_type") {
            const proIdQ = qpOrZero(propPageProId);
            const mProIdQ = qpOrZero(propPageMProId);
            const proStaQ = propPageProSta !== null && propPageProSta !== undefined && propPageProSta !== '' ? propPageProSta : 'null';
            const proCatQ = encodeURIComponent(propPageProCategory || '');
            if (contextJson?.vehicle_id) {
                navigate(`/Vehicle-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&VehId=${contextJson?.property_id ? stringToBase64(contextJson?.property_id) : null}&MVehId=${contextJson?.master_property_id ? stringToBase64(contextJson?.master_property_id) : null}`);
            } else {
                navigate(`/Prop-Home?IncId=${IncID}&IncNo=${IncNo}&IncSta=${IncSta}&ProId=${contextJson?.property_id ? stringToBase64(contextJson?.property_id) : proIdQ}&MProId=${contextJson?.master_property_id ? stringToBase64(contextJson?.master_property_id) : mProIdQ}&ProSta=true&ProCategory=${proCatQ}`);
            }
        }
    };

    useEffect(() => {
        if (!victimRequiredErrors?.length) {
            setSelectedErrorKey('');
        }
    }, [victimRequiredErrors]);

    useEffect(() => {
        if (DecEIncID && IncNo && loginAgencyID) {
            validate_IncSideBar(DecEIncID, IncNo, loginAgencyID)
        }
    }, [DecEIncID, IncNo, loginAgencyID]);

    return (
        <>
            {
                openPage ?
                    <>
                        <span className='agency-sidebar'>
                            <i className="fa fa-chevron-right " style={{ fontSize: '14px' }}></i>
                            <span className="ml-2" data-toggle={changesStatus ? "modal" : ""} data-target={changesStatus ? "#SaveModal" : ''}>
                                {
                                    openPage === "MST-Property-Dash" ? `PRO-NO-${ModNo ? ModNo : ""}`
                                        :
                                        openPage === "MST-Vehicle-Dash" ? `VIC-NO-${ModNo ? ModNo : ""}`
                                            :
                                            openPage === "MST-Arrest-Dash" ? `ARST-NO-${ArrNo ? ArrNo : ""}`
                                                :
                                                openPage === "MST-Name-Dash" ? `NAME-NO-${ModNo ? ModNo : ""}` : ''
                                }
                                <p className='agency-name-sidebar'>{agencyName ? agencyName : ''}</p>
                            </span>
                        </span>
                    </>
                    :
                    <>
                        <Link
                            to={changesStatus ? `/Inc-Home?IncId=${IncID ? IncID : ''}&IncNo=${IncNo}&IncSta=${IncSta}` : `/Inc-Home?IncId=${IncID ? IncID : ''}&IncNo=${IncNo}&IncSta=${IncSta}`} data-toggle={changesStatus ? "modal" : ""} data-target={changesStatus ? "#SaveModal" : ''}

                            className='agency-sidebar' onClick={() => {
                                setActiveArrest(false);
                            }}>
                            <i className="fa fa-chevron-right " style={{ fontSize: '14px' }}></i>
                            <span className="ml-2" data-toggle={changesStatus ? "modal" : ""} data-target={changesStatus ? "#SaveModal" : ''}>
                                INC-{IncNo ? IncNo : ""}
                                {/* INC-{!IncNo ? " " : IncNo} */}
                                <p className='agency-name-sidebar'>Case Status:-{CaseStatus ? CaseStatus : ''}</p>
                            </span>
                        </Link>
                        {
                            IncSta === true || IncSta === "true" ?
                                <>
                                    <li className='position-relative'>
                                        {/* <hr className='incSiderbar_Hr mt-1 w-100' /> */}
                                        <StatusBar
                                            ref={statusRef}
                                            loading={nibrsSideBarLoading}
                                            incidentErrorStatus={incidentErrorStatus}
                                            offenseCount={offenseCount}
                                            offenseErrorStatus={offenseErrorStatus}
                                            NameCount={NameCount}
                                            nameErrorStatus={nameErrorStatus}
                                            NameRelationshipError={NameRelationshipError}
                                            narrativeApprovedStatus={narrativeApprovedStatus}
                                            PropertyCount={PropertyCount}
                                            PropErrorStatus={PropErrorStatus}
                                            VehicleCount={VehicleCount}
                                            vehErrorStatus={vehErrorStatus}
                                        />
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            victimRequiredErrors?.length > 0 ?
                                <li className='px-2 mt-2'>
                                    <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '6px' }}>
                                        NIBRS Error
                                    </div>
                                    <div
                                        style={{
                                            maxHeight: '500px',
                                            overflowY: 'auto',
                                            paddingRight: '4px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px'
                                        }}
                                    >
                                        {victimRequiredErrors.map((errorItem, index) => (
                                            (() => {
                                                const itemKey = `${errorItem?.IssueId || index}-${index}`;
                                                const isSelected = selectedErrorKey === itemKey;
                                                const contextJson = errorItem?.ContextJson ? JSON.parse(errorItem?.ContextJson) : null;
                                                const isAssociatedOffense = errorItem?.FieldPath === 'property.associated_offense' && errorItem?.MessageTech === 'Error For Loss Code 5';
                                                const isAssociatedOffense6 = errorItem?.FieldPath === 'property.associated_offense' && errorItem?.MessageTech === 'Error For Loss Code 6';
                                                const isAssociatedOffense7 = errorItem?.FieldPath === 'property.associated_offense' && errorItem?.MessageTech === 'Error For Loss Code 7';
                                                const isAssociatedOffense8 = errorItem?.FieldPath === 'property.associated_offense' && (errorItem?.MessageTech === 'Error For Loss Code 8' || errorItem?.MessageTech === 'Error For Loss Code 1');
                                                const isLossType = errorItem?.FieldPath === 'property.loss_type';
                                                return (
                                                    <div
                                                        key={itemKey}
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => {
                                                            setSelectedErrorKey(itemKey);
                                                            if (isAssociatedOffense) {
                                                                setCategoryModalHeader('Loss Code Must be Completed');
                                                                setCategoryModalContent(ASSOCIATED_OFFENSE_CATEGORY_MESSAGE.split('\n').slice(1).join('\n'));
                                                            } else if (isAssociatedOffense6) {
                                                                setCategoryModalHeader('Loss Code Must be Completed');
                                                                setCategoryModalContent(ASSOCIATED_OFFENSE_CATEGORY_MESSAGE_6.split('\n').slice(1).join('\n'));
                                                            } else if (isAssociatedOffense7) {
                                                                setCategoryModalHeader('Loss Code Must be Completed');
                                                                setCategoryModalContent(ASSOCIATED_OFFENSE_CATEGORY_MESSAGE_7.split('\n').slice(1).join('\n'));
                                                            } else if (isAssociatedOffense8) {
                                                                setCategoryModalHeader('');
                                                                setCategoryModalContent(ASSOCIATED_OFFENSE_CATEGORY_MESSAGE_8.split('\n').slice(1).join('\n'));
                                                            } else if (isLossType) {
                                                                setCategoryModalHeader('');
                                                                setCategoryModalContent(LOSS_TYPE_CATEGORY_MESSAGE);
                                                            }
                                                            handleVictimRequiredRedirect(errorItem?.FieldPath, contextJson);
                                                        }}
                                                        style={{
                                                            position: 'relative',
                                                            backgroundColor: isSelected ? '#d85f5f' : '#F29A9A',
                                                            borderRadius: '4px',
                                                            padding: '8px 10px',
                                                            cursor: 'pointer',
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            color: '#000'
                                                        }}
                                                        title={isAssociatedOffense ? undefined : 'Go to Name Home'}
                                                    >
                                                        {errorItem?.MessagePlain}
                                                    </div>
                                                );
                                            })()
                                        ))}
                                    </div>
                                </li>
                                : null
                        }
                        {categoryModalContent && createPortal(
                            <div
                                onClick={() => { setCategoryModalContent(''); setCategoryModalHeader(''); }}
                                style={{
                                    position: 'fixed',
                                    inset: 0,
                                    zIndex: 99999,
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <div
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                        backgroundColor: '#fff',
                                        borderRadius: '8px',
                                        width: 'min(420px, 92vw)',
                                        maxHeight: '85vh',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '12px 16px',
                                            borderBottom: '1px solid #e5e7eb'
                                        }}
                                    >
                                        <h6 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#1f2937' }}>
                                            Offense falls into the below categories 👇
                                        </h6>
                                        <button
                                            type="button"
                                            onClick={() => { setCategoryModalContent(''); setCategoryModalHeader(''); }}
                                            aria-label="Close"
                                            style={{
                                                background: 'transparent',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                lineHeight: 1,
                                                color: '#6b7280'
                                            }}
                                        >
                                            <i className="fa fa-times" />
                                        </button>
                                    </div>
                                    <div
                                        style={{
                                            padding: '12px 16px',
                                            overflowY: 'auto',
                                            whiteSpace: 'pre-line',
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            color: '#1f2937',
                                            lineHeight: 1.6
                                        }}
                                    >
                                        {categoryModalHeader && (
                                            <div
                                                style={{
                                                    backgroundColor: '#A7E8C0',
                                                    border: '1px solid #2DEB7A',
                                                    borderRadius: '4px',
                                                    padding: '6px 10px',
                                                    marginBottom: '10px',
                                                    color: '#000',
                                                    fontWeight: 700
                                                }}
                                            >
                                                {categoryModalHeader}
                                            </div>
                                        )}
                                        {categoryModalContent}
                                    </div>
                                </div>
                            </div>,
                            document.body
                        )}
                        {/* <div className="sidebar-footer">
                            <div className="field-identify-color mt-1 ml-4">
                                <h6 className="mb-1 mt-2" >Field Color</h6>
                                <div className="d-flex flex-column mt-3 ml-4">
                                    {labels?.map(({ className, bgColor, text }) => (
                                        <div className="d-flex mt-2" key={text}>
                                            <span className={`${className} mt-2`}></span>
                                            <span
                                                className="ml-2"
                                                style={{
                                                    border: '1px solid', backgroundColor: bgColor,
                                                    padding: '4px', borderRadius: '4px', display: 'inline-block',
                                                    transition: 'color 0.3s ease', textAlign: "center",
                                                    fontWeight: 600, fontSize: '14px', minWidth: "90px"
                                                }}
                                            >
                                                {text}
                                            </span>
                                        </div>
                                    ))}


                                </div>
                            </div>
                        </div> */}
                    </>
            }
        </>
    )
}

export default IncSidebar
